import { EducationBase, IEducationBase } from './education-base';
import { EducationProfessional, IEducationProfessional } from './education-professional';

export interface IEducations {
  education?: IEducationBase[];
  professionalTests?: IEducationProfessional[];
}

export class Educations implements IEducations {
  education: EducationBase[];
  professionalTests: EducationProfessional[];

  constructor( educations: IEducations = {} ) {
    this.education = educations.education
      ? educations.education.map(( item ) => new EducationBase(item))
      : [];
    this.professionalTests = educations.professionalTests
      ? educations.professionalTests.map(( item ) => new EducationProfessional(item))
      : [];
  }
}



// WEBPACK FOOTER //
// ./app/core/entities/cv/education.ts